import React, { Component } from 'react';
import { NavLink } from 'react-router-dom'
import './Options.scss';

class componentName extends Component {
    render() {
        return (
            <div className="tos-options">
                <NavLink to="/about" exact className="btn base" activeClassName="secondary" >About GPbook</NavLink>
                <NavLink to="/about/tos" className="btn base" activeClassName="secondary" >Terms and Conditions</NavLink>
                <NavLink to="/about/specialist-tos" className="btn base" activeClassName="secondary">Terms for Listed Clinicians</NavLink>
                <NavLink to="/about/privacy" className="btn base" activeClassName="secondary">Privacy Policy</NavLink>
                <NavLink to="/about/disclaimer" className="btn base" activeClassName="secondary">Disclaimer</NavLink>
            </div>
        );
    }
}

export default componentName;


// WEBPACK FOOTER //
// ./src/Containers/About/Options.js